import { Injectable } from '@angular/core';
import { ResourcePathsEnum } from '../../upload-requests-api/resource-paths.enum';
import { ResourceTypesEnum } from '../../upload-requests-api/resource-types.enum';
import { UploadTypesEnum } from '../../upload-requests-api/upload-types.enum';
import { UploadProductsModalParams } from './../upload-products-modal-params';

export interface ImportEntityFields {
  uploadType: UploadTypesEnum;
  resourceType: ResourceTypesEnum;
  entityMessage: string;
  uploadTypeLabel: string;
  resourcePath?: ResourcePathsEnum | string;
}

export enum ImportEntity {
  crossReferences = 'crossReferences',
  spend = 'spend',
  agreementProductPrice = 'agreementProductPrice',
  agreementExclusions = 'agreementExclusions',
  offerPricing = 'offerPricing',
}

@Injectable({
  providedIn: 'root',
})
export class ModalConfigService {
  constructor() {}

  public getUploadResourceDataParams(
    importEntity: ImportEntity,
    options: Partial<UploadProductsModalParams> = {},
  ): ImportEntityFields {
    switch (importEntity) {
      case ImportEntity.agreementProductPrice:
        return {
          uploadTypeLabel: 'Agreement Product Price',
          uploadType: UploadTypesEnum.AGREEMENT_PRODUCT_PRICE,
          resourceType: ResourceTypesEnum.MARKETPLACE_AGREEMENT,
          resourcePath: ResourcePathsEnum.CPA + options.resourceId,
          entityMessage: 'File',
        };
      case ImportEntity.agreementExclusions:
        return {
          uploadTypeLabel: 'Agreement Exclusions',
          uploadType: UploadTypesEnum.AGREEMENT_EXCLUSIONS,
          resourceType: ResourceTypesEnum.MARKETPLACE_AGREEMENT,
          resourcePath: ResourcePathsEnum.CPA + options.resourceId,
          entityMessage: 'File',
        };
      case ImportEntity.spend:
        return {
          uploadTypeLabel: 'Purchase-History',
          uploadType: UploadTypesEnum.SPEND,
          resourceType: ResourceTypesEnum.RFP,
          entityMessage: 'Edit Spend History',
        };
      case ImportEntity.crossReferences:
      default:
        return {
          uploadTypeLabel: 'Cross-References',
          uploadType: UploadTypesEnum.CROSSREFERENCE,
          resourceType: ResourceTypesEnum.BUYER,
          resourcePath: ResourcePathsEnum.CROSSREFERENCE,
          entityMessage: 'Cross References',
        };
    }
  }
}
